export enum ReviewEnum {
  newest = 'date_desc',
  oldest = 'date_asc',
  highest = 'rate_desc',
  lowest = 'rate_asc',
  most_useful = 'most_helpful'
}

export enum MethodEnum {
  CREATE = 'create',
  DELETE = 'delete'
}

export enum ScriptPositionEnum {
  FOOTER = 'FOOTER',
  PDP_BODY = 'PDP_BODY'
}

export enum SectionEnum {
  RATING_AND_REVIEWS = 'RATING_AND_REVIEWS',
  SHOPPABLE_CONTENT = 'SHOPPABLE_CONTENT'
}
